module.exports = require("@swa-ui/shopping/src/forms/CarBookingForm/carVendorData/carVendorData.module.scss");